export default __webpack_public_path__ + "static/media/icon-delivery.13f092b0.svg";